(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('MusicSheetSearch', MusicSheetSearch);

    MusicSheetSearch.$inject = ['$resource'];

    function MusicSheetSearch($resource) {
        var resourceUrl =  'api/_search/music-sheets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
